import * as React from "react";
import { forwardRef, memo } from "react";
const SvgBd = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 12", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#006a4e", d: "M0 0h20v12H0z" }), /* @__PURE__ */ React.createElement("circle", { cx: 9, cy: 6, r: 4, fill: "#f42a41" }));
const ForwardRef = forwardRef(SvgBd);
const Memo = memo(ForwardRef);
export default Memo;
